import resource from '@api/resource';

// this is used really only on local dev environments, when deployed, should be
// served by the backend server so api host will be itself but up one level since
// the faculty assignment is one level down from the root
const apiHost = process.env.VUE_APP_API_HOST || '../';

/**
 * Just calls the regular resource get function.  Takes in the $route.query object to
 * attach on the UHID and MASK query param if available (for testing on local)
 */
function get(url, config, hostToUse, routeQuery) {
  if (routeQuery && (routeQuery.UHID || routeQuery.MASK)) {
    if (!config) {
      config = {
        queryParams: {}
      };
    }

    if (!config.queryParams) {
      config.queryParams = {};
    }

    if (routeQuery.UHID) {
      config.queryParams.UHID = routeQuery.UHID;
    }
    if (routeQuery.MASK) {
      config.queryParams.MASK = routeQuery.MASK;
    }
  }

  return resource.get(url, config, hostToUse || apiHost);
}

/**
 * Our custom WAT method to throw on the UHID if it is passed in for testing purposes.
 */
function put(url, data, hostToUse, routeQuery) {
  let urlToUse = url;
  if (routeQuery && routeQuery.UHID) {
    const queryParamConnector = urlToUse.indexOf('?') >= 0 ? '&' : '?';
    urlToUse = `${urlToUse}${queryParamConnector}UHID=${routeQuery.UHID}`;
  }
  if (routeQuery && routeQuery.MASK) {
    const queryParamConnector = urlToUse.indexOf('?') >= 0 ? '&' : '?';
    urlToUse = `${urlToUse}${queryParamConnector}MASK=${routeQuery.MASK}`;
  }
  return resource.put(urlToUse, data, hostToUse);
}

/**
 * Our custom WAT method to throw on the UHID if it is passed in for testing purposes.
 */
function postFile(url, data, hostToUse, routeQuery) {
  let urlToUse = url;
  if (routeQuery && routeQuery.UHID) {
    const queryParamConnector = urlToUse.indexOf('?') >= 0 ? '&' : '?';
    urlToUse = `${urlToUse}${queryParamConnector}UHID=${routeQuery.UHID}`;
  }
  return resource.postFile(urlToUse, data, hostToUse || apiHost)
}

/**
 * Calls the WAT validation route.
 */
function validate(routeQuery) {
  return get('api/w/facstaff/wat/validate', null, null, routeQuery);
}

export default {
  BASE_API_PATH: resource.BASE_API_PATH,
  apiHost,
  delete: resource.delete,
  get,
  post: resource.post,
  postFile,
  put,
  validate
};